import { render, staticRenderFns } from "./labelCreateNew.vue?vue&type=template&id=61139ee9&scoped=true&"
import script from "./labelCreateNew.vue?vue&type=script&lang=js&"
export * from "./labelCreateNew.vue?vue&type=script&lang=js&"
import style0 from "./labelCreateNew.vue?vue&type=style&index=0&id=61139ee9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61139ee9",
  null
  
)

export default component.exports